import { Controller } from "stimulus";
import {saveSearchChanges, saveSearchAs, renameSearch, annotationsEqual, getCurrentViewId} from '../helpers/search_helpers'
import {getState, setState} from '../search_results/state'
import Filter from '../filter'
import Cookies from 'js-cookie'
import { USER_DEFINED_DEFAULT_SEARCH_NAME } from '../constants.js.erb'

// Shared across save-search controller instances (page vs modal) when confirming "Set as Default Search"
let pendingDefaultSearchPayload = null;

const SHOW_SET_AS_DEFAULT_WARNING_COOKIE = 'ShowSetAsDefaultWarning';

export default class extends Controller {

  saveSearchModalContent = `<div>
    <div class="form-group max-width">
      <input id="nameForSearch" class="form-control contact-select" data-placeholder="Enter a name for this search" value="CURRENT_SEARCH_NAME">
    </div>
  </div>`

  saveSearchModalButtons = `<button class="btn btn-secondary" data-dismiss="modal" type="button">Cancel</button><button id="btnSaveSearchAction" data-action="click->save-search#saveSearchWithName"  data-template-id="SEARCH_TEMPLATE_HERE" class="btn btn-primary" data-dismiss="modal" type="button">Save</button>`

  // Set this when the user enters the textbox.  Clear it when done
  previousSearchName = ""

  connect() {

    // We nay have left the page to register before doing the save operation
    // Lets check and see if we should do that save now
    const cookieValue = Cookies.get('saveSearchAfterLogin');
    Cookies.remove('saveSearchAfterLogin')
    if (Flexmls.currentUser.role === 'vow') {
      switch (cookieValue) {
        case 'saveAs': {
          const saveSearchAsBtn = $('#saveSearchAsBtn')[0]
          saveSearchAsBtn.dispatchEvent(new Event('click', { bubbles: true }))
          break
        }
        case 'save': {
          const saveSearchBtn = $('#saveSearchBtn')[0]
          saveSearchAsBtn.dispatchEvent(new Event('click', { bubbles: true }))
          break
        }
      }
    }

    const filterUnchangedOnInitialLoad = this.filterUnchangedOnInitialLoad();
    if (filterUnchangedOnInitialLoad) {
      this.toggleSaveSearchButton(false)
    } else {
      this.toggleSaveSearchButton(true)
    }

    const isDefaultSearchPage = this.checkIfDefaultSearch();
    if (isDefaultSearchPage && filterUnchangedOnInitialLoad) {
      this.toggleDefaultSearchButton(false);
    } else {
      this.toggleDefaultSearchButton(true);
    }

    const tooltipTrigger = this.element.querySelector('.set-as-default-search-tooltip-trigger');
    if (tooltipTrigger && typeof $ !== 'undefined') {
      $(tooltipTrigger).popover({
        container: '#setAsDefaultSearchBtn',
        trigger: 'hover focus',
        delay: { show: 0, hide: 200 }
      });
    }
  }

  stopPropagation(evt) {
    evt.stopPropagation();
  }

  saveAs(evt) {
    evt.preventDefault()

    if (this.needsRegistration('saveAs')) {
      evt.stopImmediatePropagation()
      return
    }

    let suggestedName = $('#searchName').val()
    if (suggestedName.length > 0) {
      suggestedName += "_COPY"
    }

    let buttons = this.saveSearchModalButtons;
    if (evt.params.share) {
        buttons = `<button class="btn btn-secondary" data-dismiss="modal" type="button">Cancel</button><button id="btnSaveSearchAction" data-action="click->save-search#saveSearchWithName" data-save-search-share-param="true" data-template-id="SEARCH_TEMPLATE_HERE" class="btn btn-primary" data-dismiss="modal" type="button">Save and Share</button>`
    }

    let templateId = this.element.dataset.searchResultsQuicksearchId || this.element.dataset.saveSearchTemplateId || 'default';
    window.dispatchEvent(new CustomEvent("display-local-modal", {
      detail: {
        modalCssClasses: "modal-dialog modal-sm c-modal cart-modal",
        modalHeader: `<div class="t-title--large">Name This Search</div>`,
        modalContent: this.saveSearchModalContent.replace("CURRENT_SEARCH_NAME", suggestedName),
        modalFooterContent: buttons.replace("SEARCH_TEMPLATE_HERE",templateId),
        modalDataController: "save-search"
      }
    }));
  }

  saveSearchWithName(evt) {
    let newSearchName = $('#nameForSearch').val()
    let oldSearchName = $('#searchName').val()

    if (newSearchName.length == 0) {
      toast.warning('No name provided.  Search not saved.')
      return
    }
    if (newSearchName == oldSearchName) {
      toast.warning('Name did not change.  Search not saved.')
      return
    }

    let quicksearch_id = (evt.target.dataset.templateId === "default" ? null : evt.target.dataset.templateId)
    let filter = getState('filter').toString();
    let annotations = getState('annotations');
    let share = evt.params.share;
    saveSearchAs(filter, annotations, quicksearch_id, newSearchName, oldSearchName, share )
  }

  filterOrAnnotationsChanged(data) {
    let saveBtn = $('#saveSearchBtn')
    const defaultSearchBtn = $('#setAsDefaultSearchBtn');

    if (saveBtn.length > 0 || defaultSearchBtn.length > 0) {

      let currentFilter = getState('filter')
      let currentAnnotations = getState('annotations')
      let filterChanged = !(currentFilter.equalToOriginal($('#datasource-content').length === 0))
      let annotationsChanged = !annotationsEqual(currentAnnotations, mapSupport.original_annotations)

      if (filterChanged || annotationsChanged) {
        this.toggleSaveSearchButton(true)
      } else {
        this.toggleSaveSearchButton(false)
      }

      const isDefaultSearchPage = this.checkIfDefaultSearch();

      if (!isDefaultSearchPage) {
        this.toggleDefaultSearchButton(true);
      } else {
        if ((filterChanged || annotationsChanged)) {
          this.toggleDefaultSearchButton(true);
        } else {
          this.toggleDefaultSearchButton(false);
        }
      }
    }
  }

  filterUnchangedOnInitialLoad() {
    return this.element.dataset.currentFilterIsUnchangedOnInitialLoad === 'true';
  }

  toggleSaveSearchButton(enabled = false) {
    const button = $('#saveSearchBtn');
    if (button.length > 0) {
      if (enabled) {
        button.removeClass('disabled')
      } else {
        button.addClass('disabled')
      }
    }
  }

  toggleDefaultSearchButton(enabled = false) {
    const button = $('#setAsDefaultSearchBtn');
    if (button.length > 0) {
      if (enabled) {
        button.removeClass('disabled')
      } else {
        button.addClass('disabled')
      }
    }
  }

  checkIfDefaultSearch() {
    const defaultSearchBtn = $('#setAsDefaultSearchBtn');
    if (defaultSearchBtn.length === 0) return;

    const isDefaultSearchPage = this.checkIfDefaultSearchPage();
    if (!isDefaultSearchPage) {
      return false;
    }

    return this.checkIfDefaultSearchFilterAndAnnotations();
  }

  checkIfDefaultSearchPage() {
    return this.element.dataset.currentSearchIsDefault === 'true';
  }

  checkIfDefaultSearchFilterAndAnnotations() {
    const currentFilter = getState('filter');
    const currentAnnotations = getState('annotations');
    const filterUnchanged = currentFilter.equalToOriginal($('#datasource-content').length === 0);
    const annotationsUnchanged = annotationsEqual(currentAnnotations, mapSupport.original_annotations);

    return (filterUnchanged && annotationsUnchanged)
  }

  changingSearchName(evt) {
    // The user has entered the text box
    this.previousSearchName = evt.currentTarget.value
  }

  async searchNameChanged(evt) {
    // The user left the text box
    let $searchNameEle = $(evt.currentTarget)
    if ($searchNameEle.val() === '') {
      if (this.previousSearchName === '') {
        // The user didnt add any text to the previously empty textbox
        $searchNameEle.removeClass('value-added');
        return;
      }
      // The user left an empty text box.  Restore the previous content
      $searchNameEle.val(this.previousSearchName);
      this.previousSearchName = ''
      return;
    } else if ($searchNameEle.val() === this.previousSearchName) {
      // The user didnt change the text
      return;
    }

    if ($searchNameEle.hasClass('value-added')) {
      // Something was here before.  We must just be changing the name.
      let success = await renameSearch($searchNameEle.val())
      if (!success) {
        // Didnt work!  Change the name back to what it was.
        $searchNameEle.val(this.previousSearchName)
      }
      this.previousSearchName = ''
      return;
    }

    // We are creating a named search.  We can only do this with a quick search or a comparable search.
    // CUR-28555 Look behind searching: /(?<=\/quick_searches\/)\d{26}/ is not supported in older versions of Safari
    // Support added in Safari 16.4: https://developer.apple.com/documentation/safari-release-notes/safari-16_4-release-notes#JavaScript
    // So, for now, we use look ahead searching and we capture two groups and set the match from match[0] to match[1] until our customers catchup.
    var regex = /(?:\/quick_searches\/)(\d{26})/;
    // Extract the 26-digit number using the regular expression
    var match = window.location.href.match(regex);
    let quicksearch_id = null;
    if (match) {
      // Extracted 26-digit number
      quicksearch_id = match[1];
    } else if (window.location.href.indexOf('search/comparables_search/listings')) {
      // TODO:  Do we want to add saving capability for saving address or mls_number searches?

      // We are a flexpanel route comparable search.  We want to save this search.
      match = true;
    }

    if (!match) {
      toast.error('Unable to create a saved search from this search type.');
      return;
    }

    let filter = getState('filter').toString();
    let annotations = getState('annotations');
    saveSearchAs(filter, annotations, quicksearch_id, $searchNameEle.val(), this.previousSearchName )
  }

  async save(evt) {
    evt.preventDefault()
    let $currentTarget = $(evt.currentTarget)
    if ($currentTarget.hasClass('disabled')) return

    if (this.needsRegistration('save')) {
      evt.stopImmediatePropagation()
      return
    }

    let filter = getState('filter')
    let annotations = getState('annotations')
    let changesSaved = await saveSearchChanges(filter.toString(), annotations, this.element.dataset.searchResultsSavedsearchId)
    if (changesSaved) {
      let newUrl = new URL(window.location.href)
      newUrl.searchParams.delete('_filter')
      let myState = history.state
      myState.currentUrl = newUrl.href
      history.replaceState(myState, "", newUrl.href);

      // Because we are not reloading the page (which can take a while)
      // we need to reset the items that we check for changes
      mapSupport.originalFilter = filter.toString()
      mapSupport.filter = filter.toString()
      mapSupport.parsedFilter = filter._data

      $currentTarget.addClass('disabled')
    }
  }

  async setAsDefaultSearch(evt) {
    evt.preventDefault();

    if (evt.currentTarget.classList.contains('disabled')) return

    if (this.needsRegistration('setAsDefaultSearch')) {
      evt.stopImmediatePropagation();
      return;
    }

    const filter = getState('filter');
    const annotations = getState('annotations');
    const body = document.body;
    const quicksearch_id = body.dataset.searchResultsQuicksearchId || body.dataset.saveSearchTemplateId || 'default';
    const resolvedQuicksearchId = (quicksearch_id === 'default' ? null : quicksearch_id);

    const basePath = new URL($('body').attr('data-sub-nav-root-url')).pathname;
    const listUrl = basePath + '/saved_searches?results_type=json&search=' + encodeURIComponent(USER_DEFINED_DEFAULT_SEARCH_NAME);

    try {
      const response = await fetch(listUrl, {
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
      const data = await response.json();

      const results = data.results || [];
      const defaultSearch = results.find((r) => r.name === USER_DEFINED_DEFAULT_SEARCH_NAME);

      if (defaultSearch) {
        pendingDefaultSearchPayload = {
          filter: filter.toString(),
          annotations,
          savedSearchId: defaultSearch.id,
          options: { quickSearchId: resolvedQuicksearchId, viewId: getCurrentViewId() }
        };
        
        if (typeof Cookies.get(SHOW_SET_AS_DEFAULT_WARNING_COOKIE) !== 'undefined') {
          await this.confirmSetAsDefaultSearch();
        } else {
          window.dispatchEvent(new CustomEvent("display-local-modal", {
            detail: {
              modalCssClasses: "modal-dialog modal-sm c-modal cart-modal",
              modalHeader: `<div class="t-title--large">Set as Default Search</div>`,
              modalContent: 
              `<p>Are you sure you want to replace your existing default search with this one?</p>
              <p>Click Reset in the filter panel to return to the template.</p>
              <br>
              <div class="c-card-enable">
                <input type="checkbox" id="dontShowSetDefaultWarningAgain" />
                <label for="dontShowSetDefaultWarningAgain">Don't show again</label>
              </div>`,
              modalFooterContent: `<button class="btn btn-secondary" data-dismiss="modal" type="button">Cancel</button><button class="btn btn-primary" data-action="click->save-search#confirmSetAsDefaultSearch" type="button">Confirm</button>`,
              modalDataController: "save-search"
            }
          }));
        }
      } else {
        saveSearchAs(filter.toString(), annotations, resolvedQuicksearchId, USER_DEFINED_DEFAULT_SEARCH_NAME, '', false, { redirect: false, successMessage: "Default search has been saved." });
        this.toggleDefaultSearchButton(false);
      }
    } catch (err) {
      toast.error("An error occurred while setting the default search.");
    }
  }

  async confirmSetAsDefaultSearch() {
    const pending = pendingDefaultSearchPayload;
    if (!pending) {
      window.dispatchEvent(new CustomEvent("dismiss-local-modal"));
      return;
    }
    const { filter, annotations, savedSearchId, options } = pending;
    try {
      await saveSearchChanges(filter, annotations, savedSearchId, { ...options, successMessage: "Default search has been saved." });
    } finally {
      const suppressModalCheckbox = document.getElementById('dontShowSetDefaultWarningAgain');
      if (suppressModalCheckbox && suppressModalCheckbox.checked) {
        Cookies.set(SHOW_SET_AS_DEFAULT_WARNING_COOKIE, '1', { expires: 365, path: '/' });
      }
      pendingDefaultSearchPayload = null;
      this.toggleDefaultSearchButton(false);
      window.dispatchEvent(new CustomEvent("dismiss-local-modal"));
    }
  }

  needsRegistration(cookieInfoForSave) {
    if (Flexmls.currentUser.role === 'idx') {
      // Cannot save if we are idx.  Ask them to register or log in.
      Cookies.set('saveSearchAfterLogin', cookieInfoForSave)
      let currentUrl = new URL(window.location)
      if (currentUrl.searchParams.has('_filter')) {
        // We have to add the filter to the callback url!
        let authUrl = new URL(Flexmls.currentUser.authUri)
        let authStateUrl = new URL(decodeURIComponent(authUrl.searchParams.get('state')))
        authStateUrl.searchParams.set('_filter', currentUrl.searchParams.get('_filter'))
        authUrl.searchParams.set('state', authStateUrl.toString())
        window.location = authUrl.toString()
      } else {
        window.location = Flexmls.currentUser.authUri;
      }
      return true
    }
    return false
  }
}
